import { GetOrganizationResponseBodyType } from "@intelligems/ig-types/functions/organizations/get-organization";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { organizationsKeys } from "../queryKeys";

import { getOrg } from "./get-organization";

export const useMutateChargeId = () => {
  const queryClient = useQueryClient();
  return useMutation<GetOrganizationResponseBodyType, Error, any, any>({
    mutationFn: async (args: { chargeId: string; code?: string }) =>
      getOrg(args.chargeId, args.code),
    onSuccess: (data) => {
      queryClient.setQueryData(organizationsKeys.one, data);
    },
  });
};
